import script from "./VideoEditor.vue?vue&type=script&setup=true&lang=js"
export * from "./VideoEditor.vue?vue&type=script&setup=true&lang=js"

import "./VideoEditor.vue?vue&type=style&index=0&id=6224b828&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src1198/src/s3/00/frontend/admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6224b828"]])

export default __exports__